import { render, staticRenderFns } from "./ResellerPasswordReset.vue?vue&type=template&id=62308392&scoped=true&"
import script from "./ResellerPasswordReset.vue?vue&type=script&lang=js&"
export * from "./ResellerPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62308392",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62308392')) {
      api.createRecord('62308392', component.options)
    } else {
      api.reload('62308392', component.options)
    }
    module.hot.accept("./ResellerPasswordReset.vue?vue&type=template&id=62308392&scoped=true&", function () {
      api.rerender('62308392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ResellerPasswordReset.vue"
export default component.exports